import React from "react";
import { useTranslation } from "react-i18next";
import './index.css';


const DOMHeader =()=> {
  const {t,i18n} = useTranslation();
  return (
    <div className="dom-header">
        <div>
          {""}
        </div>
  </div>
  );
}

export default DOMHeader;
